import React, { useEffect, useState } from "react";

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "../componentes/Menu";
import dataSuper from "../hooks/Conf";
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// import CarCovid19 from "../element/CarCovid19";
// Contexto
// import dataContext from "../context/User";

// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";
import Footer from "../componentes/Footer";

import "../css/styleAdmin.css";

const AlumnosCIC19 = () => {
  const history = useHistory();

  // const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");

  if (!datos) {
    history.push("/");
  }

  datos = JSON.parse(datos);

  if (dataSuper.indexOf(datos.carnet.trim()) === -1) {
    if (dataDireccionEstudiantil.indexOf(datos.carnet.trim()) === -1) {
      history.push("/");
    }
  }  

  const [cicData, setCICData] = useState([]);
  const [cicDataSemana, setCICDataSemanasState] = useState();
  const [carnet, setCarnet] = useState({});
  const [alumno, setAlumno] = useState({});
  const [cargando, setCargando] = useState(false);

  let onSutmit = (e) => {
    e.preventDefault();
    setCargando(true);
    // GetFetch.cicovid19(datos.token, carnet).then((saldosData) => {
    //   document.getElementById("dataContenedorAlumno").style.display = "block";
    //   setCICData(saldosData);
    //   AlumnoDatos();
    // });

    GetFetch.cicovid19Permiso(datos.token, carnet).then((datosCIC) => {
      document.getElementById("dataContenedorAlumno").style.display = "block";
      setCICData(datosCIC);
      AlumnoDatos();
      setCargando(false);
    }).catch(() => setCargando(false));
    GetFetch.cicovid19PermisoSemanas(datos.token, carnet).then((datosCICS) => {
      setCICDataSemanasState(datosCICS);
    });
  };

  let carnetSet = (e) => {
    setCarnet(e.target.value);
  };

  let AlumnoDatos = () => {
    let datosAlum = GetFetch.datosAlumno(carnet, datos.token);
    datosAlum.then((data) => {
      if (data[0]) {
        setAlumno(data[0]);
      } else {
        setAlumno({});
      }
    });
  };

  useEffect(() => {
    loadMenu();
    document.getElementById("textCarnet").focus();
  }, []);

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={datos.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={datos.carnet}
            nombre={datos.nombre}
            perfil={datos.perfil}
            carrera={datos.carrera}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Control de ingreso por covid-19</h2>

        <div className="card mb-4">
          <div className="card-body">
            <form id="formUP" onSubmit={onSutmit}>
              <div className="form-group">
                <label htmlFor="textCarnet">Carnet del alumno</label>
                <input
                  id="textCarnet"
                  type="text"
                  placeholder="Carnet"
                  className="form-control"
                  onChange={carnetSet}
                />
              </div>
              <button type="submit" className="btn btn-primary">
                <i className="fa fa-search mr-2" aria-hidden="true"></i>
                Buscar
              </button>
            </form>
          </div>
        </div>

        {cargando ? <SkeletonCard rows={4} /> : null}

        {!cargando && !alumno.usuario ? (
          <EmptyState icon="fa-search" title="Busca un alumno por carnet">
            Ingresa el carnet del alumno y presiona Buscar para consultar sus permisos de ingreso.
          </EmptyState>
        ) : null}

        <div id="dataContenedorAlumno" style={{ display: "none" }}>
          <div className="card mb-4">
            <div className="card-body text-center">
              <Foto foto={alumno.usuario} alt="Alumno" />
              <h3 className="text-center">
                {alumno.usuario}
                <br></br>
                {alumno.nombres + " " + alumno.apellidos}
              </h3>
            </div>
          </div>

          {cicData
            ? cicData.map((element, key) =>
                element.activo === 1 ? (
                  <div key={key} className="alert alert-success" role="alert">
                    <i className="fa fa-calendar-check-o mr-2" aria-hidden="true"></i>
                    <b>Acceso permitido para la semana #{element.semana}.</b>{" "}
                    Recuerde usar siempre su mascarilla dentro del campus ESEN.
                  </div>
                ) : (
                  <div key={key} className="alert alert-danger" role="alert">
                    <i className="fa fa-hand-paper-o mr-2" aria-hidden="true"></i>
                    <b>No se encuentra en la lista de acceso permitido para esta semana.</b>{" "}
                    Para mayor información escribir al correo de Registro
                    Académico <b>irodriguez@esen.edu.sv</b>.
                  </div>
                )
              )
            : null}

          {cicDataSemana ? (
            <div className="card">
              <div className="card-header">
                <i className="fa fa-calendar mr-2" aria-hidden="true"></i>
                Las semanas que usted puede ingresar a ESEN son:
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Semana</th>
                        <th scope="col">Desde</th>
                        <th scope="col">Hasta</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cicDataSemana.map((element, index) => {
                        let f_inicio = new Date(element.fecha_inicio);
                        let f_fin = new Date(element.fecha_fin);
                        return (
                          <tr key={index}>
                            <td>
                              <span className="esen-chip esen-chip--info">
                                #{element.semana}
                              </span>
                            </td>
                            <td>{f_inicio.toLocaleDateString()}</td>
                            <td>{f_fin.toLocaleDateString()}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <p className="text-muted">
              Permisos no otorgados para ingresar a ESEN, para mayor
              información escribir al correo de Registro Académico{" "}
              <b>irodriguez@esen.edu.sv</b>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlumnosCIC19;
